import React, { useEffect } from 'react';

export default function Contact() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>
            {/* Contact Banner */}
            <section className='contact-banner-section'>
                <div className="contact-banner-overlay">
                    <div className="container">
                        <div className="contact-banner-content">
                            <nav aria-label="breadcrumb" className="breadcrumb-nav">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Contact Us</li>
                                </ol>
                            </nav>
                            <h1 className="contact-banner-title">Contact Us</h1>
                            <p className="contact-banner-subtitle">Triburg Freight Services LLC is more than a logistics provider - we are your transportation partner,
                                ensuring that every shipment moves smoothly, securely, and on time.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Information Section */}
            <div className="contact-section container my-5 py-4">
                <div className="row align-items-stretch">
                    {/* Contact Details */}
                    <div className="col-lg-5 mb-4">
                        <div className="contact-details-wrapper h-100">
                            <h2 className="section-heading mb-4">Get In Touch</h2>
                            <p className="section-description mb-4">
                                We're here to help and answer any question you might have.
                                We look forward to hearing from you.
                            </p>

                            {/* Address */}
                            <div className="contact-detail-item">
                                <div className="detail-icon">
                                    <i className="fas fa-map-marker-alt"></i>
                                </div>
                                <div className="detail-content">
                                    <h4>Our Location</h4>
                                    <p>PH: +97148815024</p>
                                    <p>TPLOT MOD119, ROAD NO 400, LANE N408

                                        JEBEL ALI FREEZONE, DUBAI, UAE</p>
                                </div>
                            </div>

                            {/* Email */}
                            <div className="contact-detail-item">
                                <div className="detail-icon">
                                    <i className="fas fa-envelope"></i>
                                </div>
                                <div className="detail-content">
                                    <h4>Email Us</h4>
                                    <p><a href="mailto:sales@triburg.com"><b>sales@triburg.com</b></a></p>
                                </div>
                            </div>

                            {/* Phone */}
                            <div className="contact-detail-item">
                                <div className="detail-icon mt-3">
                                    <i className="fas fa-phone-alt"></i>
                                </div>
                                <div className="detail-content">
                                    <h4>For Enquiries</h4>
                                    <p><a href="tel:++971555577410x"><b>+971 555577410</b></a></p>
                                    <p><a href="tel:+971558116620"><b>+971 558116620</b></a></p>
                                    <p><a href="tel:++971551100459"><b>+971 551100459</b></a></p>
                                </div>
                            </div>

                            {/* Social Media */}
                            <div className="social-media-section mt-4">
                                <h4 className="social-heading">Connect With Us</h4>
                                <div className="social-icons-group">
                                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon facebook">
                                        <i className="fab fa-facebook-f"></i>
                                    </a>
                                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon twitter">
                                        <i className="fab fa-twitter"></i>
                                    </a>
                                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon linkedin">
                                        <i className="fab fa-linkedin-in"></i>
                                    </a>
                                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
                                        <i className="fab fa-instagram"></i>
                                    </a>
                                    <a href="https://wa.me/971555577410" target="_blank" rel="noopener noreferrer" className="social-icon whatsapp">
                                        <i className="fab fa-whatsapp"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Map Section */}
                    <div className="col-lg-7 mb-4">
                        <div className="map-wrapper h-100">
                            <h2 className="section-heading mb-4">Find Us Here</h2>
                            <div className="map-container">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.2935812276986!2d55.0312517!3d25.0357472!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6d7e3f3c5e7b%3A0x7c3e1e9b6e4e8f9a!2sJebel%20Ali%20Free%20Zone%2C%20Dubai!5e0!3m2!1sen!2sae!4v1234567890123"
                                    width="100%"
                                    height="100%"
                                    style={{ border: 0, borderRadius: '10px' }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Triburg Location"
                                ></iframe>
                            </div>
                            <div className="business-hours mt-4">
                                <h4><i className="far fa-clock"></i> Business Hours</h4>
                                <div className="hours-list">
                                    <div className="hours-item">
                                        <span className="day">Monday - Friday:</span>
                                        <span className="time">9:00 AM - 6:00 PM</span>
                                    </div>
                                    <div className="hours-item">
                                        <span className="day">Saturday:</span>
                                        <span className="time">10:00 AM - 4:00 PM</span>
                                    </div>
                                    <div className="hours-item">
                                        <span className="day">Sunday:</span>
                                        <span className="time">Closed</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
